/**
 * React-Query hooks for the caller's own profile — currently just
 * `/settings/signoff` (2026-08-17 firm-email-template spec).
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { usersMeApi, type UpdateMeInput } from '@/lib/api/users-me';

export const usersMeKeys = {
  root: ['users-me'] as const,
};

export function useMe(opts: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: usersMeKeys.root,
    queryFn: () => usersMeApi.get(),
    enabled: opts.enabled ?? true,
  });
}

export function useUpdateMe() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (patch: UpdateMeInput) => usersMeApi.update(patch),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: usersMeKeys.root });
    },
  });
}
